<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <v-card
                :loading="loading"
        >
            <v-card-title>
                Bookings List
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="desserts"
                    :search="search"
                    class="elevation-1"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
            >
                <template v-slot:item.edit="{ item }">
                    <v-btn icon :to="'/booking/'+item.id">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                sortBy: 'id',
                sortDesc: true,
                loading:true,
                search: '',
                headers: [
                    {
                        text: 'ID',
                        align: 'left',
                        value: 'id',
                    },
                    { text: 'Date Order', value: 'date' },
                    { text: 'Customer', value: 'customer' },
                    { text: 'Check-in', value: 'checkin' },
                    { text: 'Check-out', value: 'checkout' },
                    { text: 'House', value: 'house' },
                    { text: 'Total', value: 'total' },
                    { text: 'Status', value: 'status' },
                    {
                        text: 'Edit',
                        value: 'edit' ,
                        align: 'right',
                        sortable: false,
                    },
                ],
                desserts: [],
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Bookings',
                        disabled: false,
                        to: '/bookings',
                    },
                ],
            }
        },
        methods: {
            pingPage(){
                this.$http.get("https://api.bestchoicevacation.com/orders/list",{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.desserts = [];
                    this.loading = false;
                    for(let i = 0;i<response.data.length;++i){
                        this.desserts.push({
                            id:response.data[i].id,
                            date:response.data[i].date,
                            customer:response.data[i].customer,
                            checkin:response.data[i].checkin,
                            checkout:response.data[i].checkout,
                            house:response.data[i].house,
                            total:response.data[i].total,
                            status:response.data[i].status_en,
                        });
                    }
                });
            }
        },
        mounted(){
            this.pingPage();
        }
    }
</script>
